const UPLOAD_TIMEOUT_MS = 10 * 60 * 1000;

export async function uploadFile(
    file: Blob,
    url: string,
    contentType?: string,
    onProgress?: (percent: number) => void,
): Promise<void> {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        xhr.timeout = UPLOAD_TIMEOUT_MS;
        xhr.setRequestHeader(
            'Content-Type',
            contentType ||
                (file instanceof File ? file.type : '') ||
                'application/octet-stream',
        );

        if (onProgress) {
            xhr.upload.onprogress = event => {
                if (!event.lengthComputable || event.total <= 0) {
                    return;
                }
                onProgress(Math.round((event.loaded / event.total) * 100));
            };
        }

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve();
                return;
            }
            reject(new Error(`Failed to upload file (status ${xhr.status})`));
        };

        xhr.onerror = () => {
            reject(new Error('Failed to upload file'));
        };

        xhr.ontimeout = () => {
            reject(new Error('Upload timed out'));
        };

        xhr.onabort = () => {
            reject(new Error('Upload cancelled'));
        };

        xhr.send(file);
    });
}
